/**
 * Helpers for UnifiedPostComposer → POST /api/v2/posts.
 */

import {
  buildClubPostStoredContent,
  clubComposerAttachmentForApi,
} from "../../components/Clubs/clubFeedCreatePostUtils";

/** Short normalized tags for unified composer chips. */
export function normalizeUnifiedTag(raw) {
  const s = String(raw || "")
    .trim()
    .replace(/^#+/, "")
    .replace(/[^\w-]/g, "")
    .toLowerCase();
  if (!s) return "";
  if (s.length > 18) return s.slice(0, 18);
  return s;
}

export function isReadyComposerAttachment(att) {
  return Boolean(att?.__ready && att.url);
}

/**
 * @param {object[]} attachments internal composer rows
 * @returns {object[]} rows for POST /api/v2/posts `attachments`
 */
export function buildV2AttachmentPayloadFromComposer(attachments) {
  const ready = (attachments || []).filter(isReadyComposerAttachment);
  return ready.map((a, i) => clubComposerAttachmentForApi(a, i));
}

/**
 * @param {{
 *   surface: 'community' | 'club',
 *   isMediaTab: boolean,
 *   title: string,
 *   body: string,
 *   topicId: string | null,
 *   tags: string[],
 *   clubId: number | null,
 *   attachmentRows: object[],
 * }} p
 */
export function buildV2CreatePostPayload(p) {
  const titleT = String(p.title || "").trim();
  const bodyT = String(p.body || "").trim();
  const tags = Array.isArray(p.tags) ? p.tags : [];
  const topic =
    p.topicId != null && String(p.topicId).trim() !== "" ? String(p.topicId).trim() : null;
  let clubId = null;
  if (p.clubId != null && p.clubId !== "") {
    const n = Number(p.clubId);
    if (Number.isFinite(n) && n > 0) clubId = n;
  }

  if (p.surface === "club") {
    const content =
      p.isMediaTab || !bodyT ? titleT : bodyT;
    return {
      title: titleT,
      content,
      content_format: "club_title_body_v1",
      topic,
      tags,
      club_id: clubId,
      attachments: p.attachmentRows || [],
    };
  }

  const contentPlain = p.isMediaTab ? titleT : buildClubPostStoredContent(p.title, p.body);

  return {
    title: titleT,
    content: contentPlain,
    content_format: "plain",
    topic,
    tags,
    club_id: clubId,
    attachments: p.attachmentRows || [],
  };
}
